<template>
  <div style="width: 100%;height: 100%;background-color: white;">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <el-row style="height: 100%">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <div style="margin-right: 20px">
            <div style="height: 60px;display: flex">
              <div>
                <el-button v-if="isShowBindDevice" type="primary" plain @click="bindDevice()">绑定设备</el-button>
                <el-input prefix-icon="el-icon-search" placeholder="设备编号 / 设备号码 / 服务对象" v-model="searchKeyword" style="width: 220px" @blur="blurSearch()"></el-input>
                <el-button icon="el-icon-search" type="primary" plain @click="searchWord()">搜索</el-button>
              </div>
              <div>
                <el-select v-fixZoom style="width: 100px" v-model="isonline" placeholder="请选择">
                  <el-option v-for="item in isonlinearr" :key="item.value" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
              <div>
                <el-select v-fixZoom multiple collapse-tags v-model="s_dtype" placeholder="请选择" style="width: 260px" :clearable="true" @change="changeDtype">
                  <el-option v-for="item in dtypearr" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button type="success" @click="queryDataTable">查询</el-button>
                <el-button icon="el-icon-download" type="success" @click="downloadDevice">导出</el-button>
              </div>
            </div>
            <div style="max-height: calc(100% - 110px);overflow-y: auto;">
              <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable" border style="width: 100%" highlight-current-row>
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column label="设备编号" min-width="130" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.devicetype !== 700">
                      {{scope.row.deviceid}}
                    </div>
                    <div v-else>
                      <el-tooltip placement="top" effect="dark">
                        <div slot="content">
                          <span style="font-size: 14px">版本号：</span>
                          <span style="font-size: 14px">{{scope.row.ver}}</span><br>
                          <span style="font-size: 14px">雷达监测结果：</span>
                          <span style="font-size: 14px" v-if="scope.row.radarstaus === 'tx'">休息</span>
                          <span style="font-size: 14px" v-if="scope.row.radarstaus === 'out'">动作</span><br>
                          <span style="font-size: 14px">雷达监测时间：</span>
                          <span style="font-size: 14px">{{scope.row.radartime}}</span><br>
                        </div>
                        <div>
                          <img style="vertical-align: sub;width: 20px;height: 20px"
                               src="../../../static/tableIcon/lie.png"
                               v-if="scope.row.radarstaus === 'tx'">
                          <img style="vertical-align: sub;width: 20px;height: 20px"
                               src="../../../static/tableIcon/walk.png"
                               v-if="scope.row.radarstaus === 'out'">
                          <span>{{scope.row.deviceid}}</span>
                        </div>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="设备类型" min-width="95" align="center">
                  <template slot-scope="scope">
                    <span>{{getDeviceType(scope.row.devicetype)}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="设备号码" min-width="100" align="center">
                  <template slot-scope="scope">
                    <span>{{getDevicePhone(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="电量" min-width="70" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.battery === 0"> {{scope.row.battery_voltage}} </span>
                    <span v-else>{{scope.row.battery}}%</span>
                    <span v-if="scope.row.charge === '1'">充电</span>
                    <span v-if="scope.row.charge === '0'">没有充电</span>
                  </template>
                </el-table-column>
                <el-table-column prop="last_online" label="最后在线时间" min-width="140" align="center"></el-table-column>
                <el-table-column v-if="moduletag === 3" prop="h_address" label="家庭地址/机构房间" min-width="140" align="center"></el-table-column>
                <el-table-column v-else-if="moduletag === 2" prop="h_address" label="机构房间" min-width="140" align="center"></el-table-column>
                <el-table-column v-else-if="moduletag === 1" prop="h_address" label="家庭地址" min-width="140" align="center"></el-table-column>
                <el-table-column prop="h_installlocation" label="安装位置" min-width="75" align="center"></el-table-column>
                <el-table-column prop="p_name" label="服务对象" min-width="80" align="center"></el-table-column>
                <el-table-column label="离线警报" min-width="75" align="center">
                  <template slot-scope="scope">
                    {{getNoneWork(scope.row)}}
                  </template>
                </el-table-column>
                <el-table-column prop="userName" label="绑定者" min-width="80" align="center"></el-table-column>
                <el-table-column align="center" label="操作" width="150">
                  <template slot-scope="scope">
                    <i v-if="scope.row.devicetype === 602 || scope.row.devicetype === 601 ||  scope.row.devicetype === 612 ||
                      scope.row.devicetype === 613 ||scope.row.devicetype === 406 || scope.row.devicetype === 754"
                       style="cursor: pointer; font-size: 18px;color: blue" title="设备设置"
                       class="el-icon-s-tools" @click="setBindPerson(scope.row)"></i>
                    <i v-if="scope.row.devicetype === 901" title="微聊" class="el-icon-chat-dot-round" style="cursor: pointer; font-size: 18px;color: #5db713" @click="chatDeviceOpen(scope.row)"></i>
                    <img v-if="scope.row.devicetype === 300 || scope.row.devicetype === 901 ||
                    scope.row.devicetype === 310 || scope.row.devicetype === 311 || scope.row.devicetype === 312 || scope.row.devicetype === 313" src="../../assets/tel/icon_replace.png"
                         title="更换设备" style="width: 14px;vertical-align: baseline;margin-right: 3px;cursor: pointer"
                    @click="openChange(scope.row)">
                    <i v-if="getShowMap(scope.row)" title="轨迹" style="cursor: pointer; font-size: 18px;" class="el-icon-delete-location"
                       @click="openTrackMap(scope.row)"></i>
                    <!--        [300, 350, 351, 352, 353, 901, 903, 310, 311, 312, 313, 330]            -->
                    <i v-if="scope.row.devicetype === 700 || scope.row.devicetype === 901 || scope.row.devicetype === 902 || scope.row.devicetype === 351 ||
                       scope.row.devicetype === 352 || scope.row.devicetype === 353 ||
                       scope.row.devicetype === 310 || scope.row.devicetype === 311 || scope.row.devicetype === 312 || scope.row.devicetype === 313 ||
                       scope.row.devicetype === 407 || scope.row.devicetype === 752 || scope.row.devicetype === 330 || scope.row.devicetype === 780 ||
                       scope.row.devicetype === 701 || scope.row.devicetype === 504 || scope.row.devicetype === 508 || scope.row.devicetype === 534 || scope.row.devicetype === 538"
                       style="cursor: pointer; font-size: 18px;color: blue" title="设备设置" class="el-icon-s-tools" @click="openList(scope.row)"></i>
                    <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editDevice(scope.row)"></i>
                    <i title="解绑" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top: 10px;height: 40px;text-align: center">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--created-->
    <el-dialog :visible.sync="addShow" v-if="addShow" width="650px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>绑定设备</span></div>
        <div class="line-title"></div>
      </div>
      <device-add :addDeviceRow="addRow" v-model="addShow"  @getFatherDevice="getFatherDevice"></device-add>
    </el-dialog>
    <el-dialog :visible.sync="editShow" v-if="editShow" :width="openWidth" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>编辑设备</span></div>
        <div class="line-title"></div>
      </div>
      <device-edit :deviceEditRow="addRow" v-model="editShow" @getFatherEditDevice="getFatherEditDevice"></device-edit>
    </el-dialog>
    <!--更换设备-->
    <el-dialog :visible.sync="changeDeviceShow" v-if="changeDeviceShow" width="600px" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>更换设备</span> </div>
        <div class="line-title"></div>
      </div>
      <div>
        <change-device v-model="changeDeviceShow" :changeObj="changeObj" @getFatherEditDevice="getFatherEditDevice"></change-device>
      </div>
    </el-dialog>
    <!--位置信息-->
    <el-dialog :visible.sync="trackShow" v-if="trackShow" width="1200px" :close-on-click-modal="true" top="10vh" class="all-open">
      <div class="title-top-alarm">
        <div><span>位置信息</span></div>
        <div class="line-title"></div>
      </div>
      <div style="height: 660px">
        <track-details v-model="trackShow" :trackDetailsObj="trackObj"></track-details>
      </div>
    </el-dialog>
    <!--子机详情、通讯录设置、语音通知、FM频率设置、SOS呼叫号码...-->
    <el-dialog :title="listTitle" :visible.sync="listShow" v-if="listShow" width="850px" :show-close="true" :close-on-click-modal="false" center>
      <list-tabs v-model="listShow" :listObj="listObj"></list-tabs>
    </el-dialog>
    <!--0-SOS呼叫号码、1-跌倒设置、2-闹钟设置、3-语音设置、4-蓝牙功能、5-定位设置、6-室内定位、7录音上传、8-通讯录设置-->
    <el-dialog :visible.sync="listShow901" v-if="listShow901" width="1200" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ listTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <list-tabs-cat v-model="listShow901" :listObj="listObj"></list-tabs-cat>
    </el-dialog>
    <!--9-电话本、10-白名单、11-发送消息、12-SOS报警电话、13-310闹钟提醒、14-311|313定时测量心率血氧、15-407 752滞留时长、22-701SOS号码、23-701按键号码-->
    <el-dialog :visible.sync="listShow310" v-if="listShow310" width="850px" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ listTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <list-tabs-watch310 v-model="listShow310" :listObj="listObj"></list-tabs-watch310>
    </el-dialog>
    <!--16-330亲情号、17-330白名单、18-330闹钟、19-330定位、20-SOS按键号码、21-780安装高度-->
    <el-dialog :visible.sync="listShowSet" v-if="listShowSet" width="650px" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ listTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <list-tabs-set v-model="listShowSet" :listObj="listObj"></list-tabs-set>
    </el-dialog>
    <!--  单聊  -->
    <el-dialog :visible.sync="chatOpen" v-if="chatOpen" width="1100px" :close-on-click-modal="false" center class="all-open">
      <chat-device ref="chat" v-model="chatOpen" :chatObj="chatObj"></chat-device>
    </el-dialog>
    <!--  睡眠设置  -->
    <el-dialog :visible.sync="subShow1" v-if="subShow1" width="500px" :show-close="true" :close-on-click-modal="false" center append-to-body class="all-open">
      <div class="title-top-alarm">
        <div> <span>【{{subBedObj.device.deviceid}}】设置</span> </div>
        <div class="line-title"></div>
      </div>
      <div style="height: 40px;margin: 10px 40px">
        <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
          <span>{{item.name}}</span>
        </div>
      </div>
      <sub-device-bed v-if="indexActive === 0" :subBedObj="subBedObj" v-model="subShow1"></sub-device-bed>
      <set-sleep v-if="indexActive === 1" :sleepObj="subBedObj" v-model="subShow1"></set-sleep>
    </el-dialog>
    <!-- 门磁类 504 508 534 538 设置无活动报警-->
    <el-dialog :visible.sync="listShowDoor" v-if="listShowDoor" width="850px" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ listTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <list-tabs-door v-model="listShowDoor" :listObj="listObj"></list-tabs-door>
    </el-dialog>
  </div>
</template>

<script>
import deviceEdit from './childComponents/deviceEdit'
import deviceAdd from './childComponents/deviceAdd'
import deviceAdd1 from './childComponents/deviceAdd1'
import setSleep from './deviceComponents/setSleep.vue'
import {
  querybinddevice,
  deletedevicetohome,
  deletedevicetoperson,
  searchdevice,
  querybinddevicebyoid,
  querydevicebyimei
} from '../../api/device'
import { queryorghome } from '../../api/relation'
import { queryoldperson } from '../../api/serviceObject'
import { queryorgperson } from '../../api/orguser'
import {queryorgcommunity} from '../../api/community'
import deviceParam from './childComponents/deviceParam'
import listTabs from './deviceComponents/listTabs'
import changeDevice from './deviceComponents/changeDevice'
import historyTrack from './deviceComponents/historyTrack'
import trackDetails from './deviceComponents/trackDetails'
import listTabsCat from './deviceComponents/listTabsCat'
import chatDevice from './deviceComponents/chatDevice'
import treeData from '../treeData/treeData.vue'
import subDeviceBed from './childComponents/subDeviceBed.vue'
import listTabsWatch310 from './deviceComponents/listTabsWatch310.vue'
import listTabsSet from './deviceComponents/listTabsSet.vue'
import listTabsDoor from './deviceComponents/listTabsDoor.vue'
import {queryoldpersonbypids} from '../../api/handlealarm'
export default {
  name: 'device',
  components: {
    subDeviceBed, treeData, deviceEdit, deviceAdd, deviceAdd1, deviceParam, listTabs, changeDevice, historyTrack, trackDetails, listTabsCat, chatDevice, listTabsWatch310, setSleep, listTabsSet, listTabsDoor
  },
  data () {
    return {
      isShowBindDevice: true,
      // 左边
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: [],
      hids: [],
      sendHids: [],
      isSendHid: true,
      orghomes: [],
      pids: [],
      sendPids: [],
      isSendPid: true,
      oldpersons: [],
      orgpersons: [],
      orgid: '',
      // 右边
      isonline: 0, // 0常规查询 1在线查询 2离线查询
      isonlinearr: [
        {name: '全部设备', id: 0},
        {name: '在线设备', id: 1},
        {name: '离线设备', id: 2}
      ],
      dtypedown: [], // 搜索接口 导出功能 全部选择
      dtype: [],
      all_dtype: [1, 2, 3, 4],
      s_dtype: [],
      dtypearr: [
        {name: '网关设备', id: 1},
        {name: '穿戴设备', id: 2},
        {name: 'NB设备', id: 3},
        {name: '报警设备', id: 4},
        {name: '健康设备', id: 5}
      ],
      searchKeyword: '',
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addShow: false,
      addShow1: false,
      addRow: {
        orgTree: [],
        orgcommunitys: [],
        orghomes: [],
        oldpersons: [],
        home: '',
        isGateway: false,
        row: '',
        orgids: [],
        isAddPerson: false // 是否添加人绑定设备
      },
      editShow: false,
      openWidth: '800px',
      subShow: false,
      subTitle: '',
      deviceRow: {},
      openDetails: false,
      voiceObj: {
        device: '',
        org: [],
        community: [],
        home: [],
        push_type: 2
      },
      telObj: {
        row: '',
        oldpersons: []
      },
      telShow: false,
      telTitle: '',
      listObj: {
        deviceRow: '',
        // lisTabsCat不显示SOS/蓝牙/室内定位
        test: ''
      },
      listShow: false,
      listTitle: '',
      moduletag: '',
      changeDeviceShow: false,
      changeObj: {
        deviceRow: ''
      },
      trackShow: false,
      trackObj: {
        type: 'device',
        lng: '',
        lat: '',
        deviceRow: ''
      },
      // 901设置弹窗
      listShow901: false,
      listShow310: false,
      // 设备设置
      listShowSet: false,
      listShowDoor: false,
      // 微聊
      chatOpen: false,
      chatObj: {
        deviceRow: ''
      },
      // 睡眠带绑定人
      tabs: [
        {index: 0, name: '分配老人'},
        {index: 1, name: '睡眠设置'}
      ],
      indexActive: 0,
      subShow1: false,
      subBedObj: {
        isMain: true,
        device: ''
      }
    }
  },
  created () {
    if (window.location.host === 'newjky.wecare-u.net' || window.location.host === 'newhealth.wecare-u.net' ||
      window.location.host === 'kangnh.com' || window.location.host === 'bengshan.kangnh.com') { // 上海更换
      this.isShowBindDevice = false
    } else {
      this.isShowBindDevice = true
    }
    this.moduletag = this.$store.state.user.moduletag
    // 设备参数设置 搜索
    this.golobleObject.updateTableDevice = this.getFatherEditDevice
    // 单聊刷新
    this.golobleObject.mqttChat = this.getMqttChat
    this.orgid = this.$store.state.user.orgid
    this.getCommunity()
    this.getQueryOrgHome()
    this.getOldPerson()
    this.dtypedown = this.commonType.getDeviceTypeArr()
    this.golobleObject.addSubNew = this.getDevice
  },
  mounted () {
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
    },
    getMqttChat (obj) {
      if (this.chatOpen) {
        this.$refs.chat.getMattData(obj)
      }
    },
    getCommunity () {
      queryorgcommunity().then(res => {
        this.voiceObj.community = res.data.orgcommunitys
        this.addRow.orgcommunitys = res.data.orgcommunitys
      }).catch(() => {})
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    checkChange (obj) {
      if (obj.type === 'check') {
        this.searchKeyword = ''
        this.dtype = this.dtypedown
        this.s_dtype = this.all_dtype
        this.currentPage = 1
        this.isFirst = obj.orgids
        this.addRow.orgids = this.isFirst
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else if (obj.type === 'data') {
        this.orgData = obj.orgData
        this.voiceObj.org = obj.orgData
        this.addRow.orgTree = obj.orgData
        this.getUserTable()
      }
    },
    // 添加
    bindDevice () {
      this.addRow.row = ''
      this.addShow = true
    },
    // 家庭
    getQueryOrgHome () {
      queryorghome().then(res => {
        this.orghomes = res.data.orghomes
        this.addRow.orghomes = res.data.orghomes
        console.log('家庭', this.addRow.orghomes)
      }).catch(() => {})
    },
    // 查询老人
    getOldPerson () {
      let data = {
        orgid: this.orgid
      }
      queryoldperson(data).then(res => {
        this.oldpersons = res.data.oldpersons
        this.addRow.oldpersons = res.data.oldpersons
      }).catch(() => {})
    },
    // 绑定者（平台人员）
    getUserTable () {
      this.loading = true
      queryorgperson().then(res => {
        this.orgpersons = res.data.orgpersons
        this.queryBindDevice()
      }).catch(() => {
        this.loading = false
      })
    },
    // 表格
    queryBindDevice () {
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        isonline: this.isonline
      }
      let dtype = this.clone(this.dtype)
      if (this.dtype.indexOf(300) > 0) {
        dtype.push(350)
      }
      let data = {
        dtype: dtype
      }
      querybinddevice(params, data).then(res => {
        this.loading = false
        this.totalCells = res.data.cnt
        this.tableData = res.data.devices
        this.showTable = []
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          let obj = this.tableData[i]
          obj.userName = this.getOrgPersons(obj.oid)
          arr.push(obj)
        }
        this.showTable = arr
      }).catch(() => {
        this.loading = false
      })
    },
    queryBindDeviceByOid () {
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        isonline: this.isonline
      }
      let data = {
        oids: this.isFirst,
        dtype: this.dtype
      }
      querybinddevicebyoid(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.devices
        this.showTable = []
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          let obj = this.tableData[i]
          obj.userName = this.getOrgPersons(obj.oid)
          arr.push(obj)
        }
        this.showTable = arr
      }).catch(() => {})
    },
    getNoneWork (row) {
      let aa = row.p_nonetwork
      if (aa === '1') {
        return '开启'
      } else if (aa === '0') {
        return '关闭'
      } else {
        return aa
      }
    },
    getDeviceType (type) {
      return this.commonType.getDeviceType(type)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        if (row.pid > 0) {
          return row.p_phone
        } else {
          return row.h_phone
        }
      }
    },
    getOrgPersons (oid) {
      let userName = ''
      for (let i = 0; i < this.orgpersons.length; i++) {
        if (oid === this.orgpersons[i].id) {
          userName = this.orgpersons[i].name
        }
      }
      return userName
    },
    // 编辑设备
    editDevice (row) {
      // console.log(111)
      if (row.devicetype === 700 || row.devicetype === 504) {
        this.openWidth = '800px'
      } else {
        this.openWidth = '600px'
      }
      this.addRow.row = row
      this.editShow = true
    },
    getFatherEditDevice () {
      // console.log(this.isFirst.length)
      this.currentPage = 1
      this.searchKeyword = ''
      if (this.isFirst.length === 0) {
        this.queryBindDevice()
      } else {
        this.queryBindDeviceByOid()
      }
    },
    getFatherDevice () {},
    // 删除设备
    delDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将永久解绑该设备【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.endDelDevice(row)
      }).catch(() => {})
    },
    endDelDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将清除与此设备【' + name + '】有关的所有数据并解绑该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        if (row.devicetype === 300 || row.devicetype === 901 || row.devicetype === 350 ||
          row.devicetype === 351 || row.devicetype === 352 || row.devicetype === 353 || row.devicetype === 310 ||
          row.devicetype === 311 || row.devicetype === 312 || row.devicetype === 313) {
          let data = {
            dids: [row.id]
          }
          deletedevicetoperson(data).then(res => {
            this.searchKeyword = ''
            this.currentPage = 1
            if (this.isFirst.length === 0) {
              this.queryBindDevice()
            } else {
              this.queryBindDeviceByOid()
            }
            this.$notify({
              title: '成功',
              message: '删除设备成功',
              type: 'success',
              duration: 2000
            })
          }).catch(() => {})
        } else {
          let data = {
            dids: [row.id]
          }
          deletedevicetohome(data).then(res => {
            this.searchKeyword = ''
            this.currentPage = 1
            if (this.isFirst.length === 0) {
              this.queryBindDevice()
            } else {
              this.queryBindDeviceByOid()
            }
            this.$notify({
              title: '成功',
              message: '删除设备成功',
              type: 'success',
              duration: 2000
            })
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    setBindPerson (row) {
      this.subBedObj.device = row
      this.subShow1 = true
    },
    getDevice () {
      if (this.isFirst.length === 0) {
        this.queryBindDevice()
      } else {
        this.queryBindDeviceByOid()
      }
    },
    openChange (row) {
      this.changeObj.deviceRow = row
      this.changeDeviceShow = true
    },
    changeDtype () {
      let arr = []
      // 700, 300, 901, 902, 903, 504, 506, 507, 508, 509, 510, 511, 601, 602, 612, 613, 850, 851, 852, 904, 905, 350, 405, 406,
      // 407, 310, 311, 312, 351, 352, 353, 750, 751, 311, 536, 537, 538, 539, 540, 541, 542, 753, 754, 533, 534, 313
      this.s_dtype.forEach(item => {
        if (item === 1) {
          arr = arr.concat([700, 850, 851, 852])
        } else if (item === 2) {
          arr = arr.concat([300, 901, 350, 310, 313, 311, 312, 351, 352, 353])
        } else if (item === 3) {
          arr = arr.concat([504, 506, 507, 508, 509, 510, 511, 751])
        } else if (item === 4) {
          arr = arr.concat([200, 400, 501, 502, 504, 902, 601, 602, 612, 613, 405, 904, 905, 331, 536, 537, 538, 539, 540, 541, 542, 533, 534])
        } else if (item === 5) {
          arr = arr.concat([750, 406, 407, 753, 754])
        }
      })
      this.dtype = arr
    },
    queryDataTable () {
      this.currentPage = 1
      this.searchKeyword = ''
      if (this.searchKeyword === '') {
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else {
        this.searchWord1()
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      if (this.searchKeyword === '') {
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else {
        this.searchWord1()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.searchKeyword === '') {
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else {
        this.searchWord1()
      }
    },
    blurSearch () {
      this.searchKeyword = this.searchKeyword.replace(/\s*/g, '')
      if (this.searchKeyword === '') {
        this.currentPage = 1
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      }
    },
    searchWord () {
      this.isonline = 0
      this.currentPage = 1
      this.searchWord1()
    },
    searchWord1 () {
      let data = {
        lessdeviceid: this.searchKeyword,
        page: this.currentPage,
        size: this.pageSize,
        dtype: this.dtypedown
      }
      searchdevice(data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.devices
        this.showTable = []
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          let obj = this.tableData[i]
          obj.userName = this.getOrgPersons(obj.oid)
          arr.push(obj)
        }
        this.showTable = arr
      }).catch(() => {})
    },
    openList (row) {
      // 300 2g手表不用加, 350 第三方手表暂时不加定位设置, 351 352 353暂时不加定位设置
      this.listTitle = '【' + row.deviceid + '】' + '设置'
      if (row.devicetype === 351 || row.devicetype === 352 || row.devicetype === 353) {
        this.listTitle = '【' + row.deviceid + '】' + '设置呼叫号码'
      }
      this.listObj.deviceRow = row
      if (row.devicetype === 901 || row.devicetype === 901) {
        this.listShow901 = true
        this.listObj.test = false
      } else if (row.devicetype === 310 || row.devicetype === 311 || row.devicetype === 312 || row.devicetype === 313 ||
        row.devicetype === 407 || row.devicetype === 752 || row.devicetype === 701) {
        this.listShow310 = true
      } else if (row.devicetype === 330 || row.devicetype === 331 || row.devicetype === 780) {
        this.listShowSet = true
      } else if (row.devicetype === 504 || row.devicetype === 508 || row.devicetype === 534 || row.devicetype === 538) { // 504 508 534 538
        this.listShowDoor = true
      } else { // 351 352 353
        this.listShow = true
      }
    },
    getShowMap (row) {
      return this.commonType.getMapDevice(row.devicetype)
    },
    openTrackMap (row) {
      this.trackObj.deviceRow = row
      let data = {
        imei: row.deviceid
      }
      querydevicebyimei(data).then(res => {
        this.trackObj.lat = res.data.device.Position.lat
        this.trackObj.lng = res.data.device.Position.lng
        let data1 = {
          pids: [row.pid]
        }
        queryoldpersonbypids(data1).then(res => {
          if (res.data.persons.length > 0) {
            row.person = res.data.persons[0]
          }
          this.trackShow = true
        }).catch(() => {})
      }).catch(() => {})
      // this.trackShow = true
    },
    chatDeviceOpen (row) {
      this.chatObj.deviceRow = row
      this.chatOpen = true
    },
    // 导出
    downloadDevice () {
      this.$message({type: 'info', message: '数据加载中，请耐心等待。', duration: 0})
      let params = {page: 1, size: 10, isonline: 0}
      let data = {dtype: this.dtypedown}
      querybinddevice(params, data).then(res => {
        if (res.data.cnt === 0) {
          this.$message.closeAll()
          this.$message({
            type: 'success',
            message: '暂无报警信息。'
          })
        } else {
          this.download1(res.data.cnt)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download1 (cnt) {
      let params = {page: 1, size: cnt, isonline: 0}
      let data = {dtype: this.dtypedown}
      querybinddevice(params, data).then(res => {
        this.$message.closeAll()
        let arr = res.data.devices
        this.download2(arr)
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download2 (arr) {
      let title = '地址'
      if (this.moduletag === 1) {
        title = '家庭地址'
      } else if (this.moduletag === 2) {
        title = '机构房间'
      } else if (this.moduletag === 3) {
        title = '家庭地址/机构房间'
      }
      let list = []
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        obj.devicetypename = this.commonType.getDeviceType(obj.devicetype)
        obj.devicePhone = this.getDevicePhone(obj)
        obj.batteryName = obj.battery + '%'
        obj.nonetWorkName = this.getNoneWork(obj)
        obj.userName = this.getOrgPersons(obj.oid)
        list.push(obj)
      }
      import('../../vendor/Export2Excel').then(excel => {
        const tHeader = ['设备编号', '设备类型', '设备号码', '电量', '最后在线时间', title, '安装位置', '服务对象', '离线警报', '绑定者']
        const filterVal = ['deviceid', 'devicetypename', 'devicePhone', 'batteryName', 'last_online', 'h_address', 'h_installlocation', 'p_name', 'nonetWorkName', 'userName']
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '设备列表'
        })
      })
      setTimeout(() => {
        this.$message.closeAll()
      }, 1500)
    },
    // this.commonType.getDeviceType(type)
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/device.vue